




















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Axios from 'axios';

@Component({
	beforeRouteEnter: (to, from, next) => {
		next((vm) => vm.$data.prevRoute = from.fullPath);
	},
})
export default class Login extends Vue {
	public loading = false;
	public login = '';
	public password = '';
	public prevRoute = '';
	public errors: string | null = null;

	public created() {
		if (localStorage.getItem('token')) {
			this.$router.back();
		}
		window.addEventListener('keydown', this.onKeyDownHandler);
	}
	public beforeDestroy() {
		window.removeEventListener('keydown', this.onKeyDownHandler);
	}
	private onKeyDownHandler(ev: KeyboardEvent) {
		if (ev.key === 'Enter') {
			this.logIn();
		}
	}
	private logIn() {
		this.loading = true;
		Axios.post('/api/account/', { login: this.login, password: this.password })
			.then((r) => {
				this.loading = false;
				if (r.data.errors) {
					this.errors = r.data.errors;
				} else {
					localStorage.setItem('token', r.data.token);
					location.href = '/';
				}
			});
	}
}
